import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  root: {
    background: foundations.colors.gray100,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '24px',
    height: 'calc(100% - 70px)',
  },
  content: {
    flexBasis: '100%',
    maxWidth: '100%',
    minWidth: '1px',
  },
  contentHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttons: {
    marginBottom: '8px',
    '& button': {
      marginLeft: '8px',
    },
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: foundations.colors.gray200,
    width: '100%',
    padding: '16px',
    margin: '16px 0',
  },
  organizeStoriesText: {
    letterSpacing: '0.58px',
    fontWeight: foundations.typography.fontWeight.normal,
  },
  organizeStoriesDescText: {
    fontWeight: foundations.typography.fontWeight.light,
    marginTop: '8px',
  },
  storiesTable: {
    display: 'flex',
    width: '100%',
    height: 'calc(100% - 127px)',
    overflow: 'auto',
  },
});
